export default __webpack_public_path__ + "static/media/9.8c5738d8.jpg";